<template>
  <div>
    <welfare-list v-show="tabType === 1" @handleShow="handleShow" :sourceType="1" />
    <course-show v-if="tabType === 2" :rowItem="rowItem" :sourceType="sourceType" @handleShow="handleShow" />
    <repair-plan-list v-if="tabType === 3" :rowItem="rowItem" @handleShow="handleShow"  />
    <chapter-list v-if="tabType === 4" :rowItem="rowItem" @handleShow="handleShow"  />
    <courseware-list v-if="tabType === 5" :rowItem="rowItem" @handleShow="handleShow"  />
    <lecturer-show v-if="tabType === 6" :isCourse="1" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import welfareList from '../course/list.vue'
import repairPlanList from '../course/repairPlan/index.vue'
import chapterList from '../course/chapter/index.vue'
import coursewareList from '../course/courseware/index.vue'
import courseShow from '../course/show.vue'
import lecturerShow from '../lecturer/show.vue'
export default {
  components: { welfareList, repairPlanList, chapterList, coursewareList, courseShow, lecturerShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>